import React from 'react';
import { cn } from '@/lib/utils';

interface AdPlaceholderProps {
  type: 'banner' | 'skyscraper';
  className?: string;
}

export const AdPlaceholder: React.FC<AdPlaceholderProps> = ({ type, className }) => {
  const isBanner = type === 'banner';
  
  return (
    <div
      className={cn(
        "border border-border/60 bg-muted/30 flex flex-col justify-center items-center relative",
        isBanner 
          ? "h-24 md:h-20 w-full max-w-3xl mx-auto" // 728x90 banner responsive
          : "w-40 h-[600px]", // 160x600 skyscraper
        className
      )}
    >
      {/* Ad Label */}
      <div className="absolute top-1 left-1">
        <span className="text-xs text-muted-foreground bg-background/80 px-1.5 py-0.5 rounded font-medium">
          Ad
        </span>
      </div>
      
      {/* Ad Content */}
      <div className="text-center px-4 py-2">
        {isBanner ? (
          <div className="space-y-1">
            <div className="text-sm font-medium text-foreground/80">
              💰 Financial Calculator Pro
            </div>
            <div className="text-xs text-muted-foreground">
              Advanced percentage & finance tools for professionals
            </div>
          </div>
        ) : (
          <div className="space-y-3 w-full">
            <div className="w-24 h-16 bg-primary/10 rounded mx-auto flex items-center justify-center">
              <span className="text-xs text-primary">📊</span>
            </div>
            <div className="space-y-1">
              <div className="text-sm font-medium text-foreground/80">
                Math Tutoring
              </div>
              <div className="text-xs text-muted-foreground leading-relaxed">
                Expert help with percentages, algebra & more. 
              </div>
              <div className="text-xs text-primary font-medium">
                Start Free Trial
              </div>
            </div>
            
            <div className="border-t border-border/40 pt-3 mt-4">
              <div className="w-20 h-12 bg-secondary/60 rounded mx-auto mb-2 flex items-center justify-center">
                <span className="text-xs">🏦</span>
              </div>
              <div className="text-xs text-muted-foreground">
                Best Savings Rates
              </div>
              <div className="text-xs text-primary">
                Compare Now
              </div>
            </div>
          </div>
        )}
      </div>
      
      {/* Google AdSense style attribution */}
      <div className="absolute bottom-0 right-1 text-[10px] text-muted-foreground/60">
        AdSense
      </div>
    </div>
  );
};